var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        opacity: .8;\n      }\n\n      .cls-2, .cls-5, .cls-3, .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        fill: #dbdbdb;\n      }\n\n      .cls-7, .cls-5 {\n        opacity: .5;\n      }\n\n      .cls-8 {\n        fill: #37474f;\n      }\n\n      .cls-9 {\n        fill: #455a64;\n      }\n\n      .cls-10 {\n        fill: #a6a6a6;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n        opacity: .52;\n      }\n\n      .cls-12 {\n        fill: #c7c7c7;\n      }\n\n      .cls-5, .cls-13 {\n        fill: #ffc727;\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        opacity: .7;\n      }\n\n      .cls-16 {\n        fill: #ebebeb;\n      }\n\n      .cls-17 {\n        fill: none;\n      }\n\n      .cls-4 {\n        opacity: .9;\n      }\n\n      .cls-18 {\n        fill: #263238;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2.9,
    y: 1.08,
    width: 184.62,
    height: 107.84
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 92.43,
    cy: 99.87,
    fx: 92.43,
    fy: 99.87,
    r: 101.53,
    gradientTransform: "translate(4.25 192.13) rotate(-89.89) scale(1 .88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#51a1e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7db9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b5d7f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ddecf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f5fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 82.51,
    y1: 101.44,
    x2: 82.51,
    y2: 41.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9c4c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c3d6d4",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9e5e4",
    stopOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2.9,
    y: -18.24,
    width: 184.62,
    height: 119.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.3,32.28h-34.06s1.69-2.09,3.56-2.33c0,0,3.63-10.15,9.71-10.22,5.65-.07,7.92,6.26,7.92,6.26,0,0,2.62-2.83,5.12-1.54s3.92,5,3.92,5c0,0,2.83,1.4,3.84,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.05,49.79h-24.18s1.2-1.64,2.52-1.83c0,0,2.58-7.97,6.89-8.03,4.01-.06,5.62,4.91,5.62,4.91,0,0,1.86-2.22,3.63-1.21s2.78,3.93,2.78,3.93c0,0,2.01,1.1,2.73,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m159.63,32.64h-40.95s2.04-2.51,4.27-2.8c0,0,4.37-12.2,11.67-12.28,6.8-.09,9.52,7.52,9.52,7.52,0,0,3.15-3.4,6.16-1.85,3.01,1.55,4.71,6.02,4.71,6.02,0,0,3.4,1.68,4.62,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.09,29.71h25.07s-1.24-1.52-2.62-1.71c0,0-2.67-7.46-7.14-7.51-4.16-.05-5.82,4.59-5.82,4.59,0,0-1.92-2.09-3.76-1.13s-2.88,3.67-2.88,3.67c0,0-2.07,1.04-2.84,2.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 127.95,
    y: 58.35,
    width: 14.46,
    height: 42.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 130.01,
    y: 54.71,
    width: 12.4,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 129.54,
    y: 60.25,
    width: 11.29,
    height: 40.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 64.16,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 68.17,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 72.18,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 76.2,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 80.21,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 84.22,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 88.23,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 92.24,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 96.26,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.54,
    y: 100.27,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 142.41,
    y: 58.35,
    width: 9.06,
    height: 42.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 142.41,
    y: 54.71,
    width: 7.7,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 143.66,
    y: 60.25,
    width: 6.96,
    height: 40.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 64.16,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 68.17,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 72.18,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 76.2,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 80.21,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 84.22,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 88.23,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 92.24,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 96.26,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 143.66,
    y: 100.27,
    width: 6.96,
    height: 0.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 13.55,
    y: 76.13,
    width: 11.18,
    height: 25.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 15.3,
    y: 78.3,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 15.3,
    y: 81.59,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 15.3,
    y: 84.87,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 15.3,
    y: 88.16,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 15.3,
    y: 91.44,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 15.3,
    y: 94.73,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 15.3,
    y: 98.02,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.15,
    y: 78.3,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.15,
    y: 81.59,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.15,
    y: 84.87,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.15,
    y: 88.16,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.15,
    y: 91.44,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.15,
    y: 94.73,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.15,
    y: 98.02,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 20.99,
    y: 78.3,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 20.99,
    y: 81.59,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 20.99,
    y: 84.87,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 20.99,
    y: 88.16,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 20.99,
    y: 91.44,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 20.99,
    y: 94.73,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 20.99,
    y: 98.02,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 24.72,
    y: 76.13,
    width: 7.84,
    height: 25.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 30.15,
    y: 97.77,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 30.15,
    y: 94.49,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 30.15,
    y: 91.2,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 30.15,
    y: 87.92,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 30.15,
    y: 84.63,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 30.15,
    y: 81.34,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 30.15,
    y: 78.06,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.84,
    y: 97.77,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.84,
    y: 94.49,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.84,
    y: 91.2,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.84,
    y: 87.92,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.84,
    y: 84.63,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.84,
    y: 81.34,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.84,
    y: 78.06,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 25.53,
    y: 97.77,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 25.53,
    y: 94.49,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 25.53,
    y: 91.2,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 25.53,
    y: 87.92,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 25.53,
    y: 84.63,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 25.53,
    y: 81.34,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 25.53,
    y: 78.06,
    width: 1.61,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 94.16,
    y: 71.67,
    width: 14.73,
    height: 29.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 96.47,
    y: 74.23,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 96.47,
    y: 78.1,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 96.47,
    y: 81.97,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 96.47,
    y: 85.83,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 96.47,
    y: 89.71,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 96.47,
    y: 93.57,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 96.47,
    y: 97.44,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.22,
    y: 74.23,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.22,
    y: 78.1,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.22,
    y: 81.97,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.22,
    y: 85.83,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.22,
    y: 89.71,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.22,
    y: 93.57,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.22,
    y: 97.44,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 103.96,
    y: 74.23,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 103.96,
    y: 78.1,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 103.96,
    y: 81.97,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 103.96,
    y: 85.83,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 103.96,
    y: 89.71,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 103.96,
    y: 93.57,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 103.96,
    y: 97.44,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 99.08,
    y: 68.59,
    width: 9.81,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 102.67,
    y: 66.68,
    width: 6.22,
    height: 1.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 108.83,
    y: 71.67,
    width: 10.33,
    height: 29.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.99,
    y: 97.15,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.99,
    y: 93.28,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.99,
    y: 89.42,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.99,
    y: 85.54,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.99,
    y: 81.68,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.99,
    y: 77.81,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.99,
    y: 73.94,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.94,
    y: 97.15,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.94,
    y: 93.28,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.94,
    y: 89.42,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.94,
    y: 85.54,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.94,
    y: 81.68,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.94,
    y: 77.81,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.94,
    y: 73.94,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 109.89,
    y: 97.15,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 109.89,
    y: 93.28,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 109.89,
    y: 89.42,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 109.89,
    y: 85.54,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 109.89,
    y: 81.68,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 109.89,
    y: 77.81,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 109.89,
    y: 73.94,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 108.83,
    y: 68.59,
    width: 8.77,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 108.83,
    y: 66.68,
    width: 4.75,
    height: 1.91
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 32.47,
    y: 36.9,
    width: 12.27,
    height: 64.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 38.99,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 38.99,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 43.16,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 43.16,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 47.33,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 47.33,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 51.5,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 51.5,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 55.67,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 55.67,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 59.84,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 59.84,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 64.01,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 64.01,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 68.19,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 68.19,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 72.35,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 72.35,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 76.53,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 76.53,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 80.7,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 80.7,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 84.87,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 84.87,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 89.04,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 89.04,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 34.37,
    y: 93.21,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 93.21,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 89.04,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 84.87,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 80.7,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 76.53,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 72.36,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 68.18,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 64.01,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 59.84,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 55.67,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 51.5,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 47.33,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 43.16,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 40.45,
    y: 38.99,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 37.43,
    y: 93.21,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 44.74,
    y: 36.9,
    width: 9.68,
    height: 64.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 93.21,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 93.21,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 89.04,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 89.04,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 84.87,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 84.87,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 80.7,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 80.7,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 76.53,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 76.53,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 72.36,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 72.36,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 68.18,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 68.18,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 64.01,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 64.01,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 59.84,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 59.84,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 55.67,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 55.67,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 51.5,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 51.5,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 47.33,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 47.33,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 43.16,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 43.16,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.45,
    y: 38.99,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 38.99,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 43.16,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 47.33,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 51.5,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 55.67,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 59.84,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 64.01,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 68.19,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 72.35,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 76.53,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 80.7,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 84.87,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 89.04,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 46.43,
    y: 93.21,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 48.93,
    y: 38.99,
    width: 1.97,
    height: 2.46
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m150.1,54.71h-20.09v3.64h-2.06v42.89h1.59s11.29,0,11.29,0h0s1.58,0,1.58,0h1.25s6.96,0,6.96,0h0s.84,0,.84,0v-42.89h-1.36v-3.64Zm-32.5,13.87h-4.01v-1.91h-10.92v1.91h-3.59v3.08h-4.92v29.57h25.01v-29.57h-1.56v-3.08Zm-72.86-31.69h-12.27v39.23H13.55v25.11h40.87V36.9h-9.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m170.97,79.2s6.05,13.44-3.83,13.45c-9.88.01-3.49-13.9-3.49-13.9,0,0-2.29-1,.36-8.51,2.64-7.5,3.83-7.51,4.93-7.51,1.39,0,2.7,3.25,1.75,8.23,0,0,3.48,6.22.28,8.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "166.28 101.57 167.21 81.31 168.18 101.57 166.28 101.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "166.83 89.8 170.41 85.61 167.6 90.36 166.83 89.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m20.46,79.2s6.05,13.44-3.83,13.45c-9.88.01-3.49-13.9-3.49-13.9,0,0-2.29-1,.36-8.51,2.64-7.5,3.83-7.51,4.93-7.51,1.39,0,2.7,3.25,1.75,8.23,0,0,3.48,6.22.28,8.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "15.76 101.57 16.7 81.31 17.67 101.57 15.76 101.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "16.32 89.8 19.9 85.61 17.09 90.36 16.32 89.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m43.25,78.47s-3.11-1.23-5.58,3.07c-2.53,4.41.65,7.31,3.17,5.58,0,0,1.98,4.15,5.93,3.15s4.59-4.15,4.59-4.15c0,0,3.51.24,3.6-2.37s-2.47-4.94-2.47-4.94c0,0-.16-6.52-4.4-6.47-4.25.05-4.83,6.13-4.83,6.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "46.16 101.57 47.03 82.17 47.94 101.57 46.16 101.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "46.76 89.44 44.04 84.02 47.3 88.6 46.76 89.44"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--high-school-building--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 70.23,
    y: 38.05,
    width: 49.54,
    height: 69.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70.23,
    y: 38.05,
    width: 49.54,
    height: 69.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 77.32,
    y: 83.77,
    width: 35.37,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 84.2,
    y: 85.55,
    width: 21.63,
    height: 20.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.65,
    y: 87.04,
    width: 18.72,
    height: 18.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "104.37 94.85 104.37 98.33 96.94 105.76 93.47 105.76 104.37 94.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "90.54 87.04 85.65 91.92 85.65 88.45 87.06 87.04 90.54 87.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "100.98 87.04 85.65 102.37 85.65 100.64 99.25 87.04 100.98 87.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "104.37 100.13 104.37 101.87 100.48 105.76 98.74 105.76 104.37 100.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "104.37 88.78 104.37 89.09 87.71 105.76 87.39 105.76 104.37 88.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "92.57 87.04 85.65 93.95 85.65 93.63 92.24 87.04 92.57 87.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "98.46 87.04 85.65 99.85 85.65 99.52 98.14 87.04 98.46 87.04"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 94.41,
    y: 87.04,
    width: 1.2,
    height: 18.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 77.96,
    y: 45.59,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.76,
    y: 46.47,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 76.85,
    y: 57.56,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "84.89 46.47 84.89 47.73 78.75 53.86 78.75 51.53 83.82 46.47 84.89 46.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "84.89 54.04 84.89 55.2 83.41 56.68 82.25 56.68 84.89 54.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "80.82 46.47 78.75 48.53 78.75 47.36 79.65 46.47 80.82 46.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "84.89 52.21 84.89 52.59 80.79 56.68 80.42 56.68 84.89 52.21"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 77.96,
    y: 52.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 91.14,
    y: 45.59,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 91.94,
    y: 46.47,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 90.03,
    y: 57.56,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "98.07 46.47 98.07 47.73 91.93 53.86 91.93 51.53 97 46.47 98.07 46.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "98.07 54.04 98.07 55.2 96.59 56.68 95.42 56.68 98.07 54.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "94 46.47 91.93 48.53 91.93 47.36 92.83 46.47 94 46.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "98.07 52.21 98.07 52.59 93.97 56.68 93.59 56.68 98.07 52.21"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 91.14,
    y: 52.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 104.32,
    y: 45.59,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 105.11,
    y: 46.47,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 103.21,
    y: 57.56,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "111.25 46.47 111.25 47.73 105.11 53.86 105.11 51.53 110.18 46.47 111.25 46.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "111.25 54.04 111.25 55.2 109.77 56.68 108.6 56.68 111.25 54.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "107.18 46.47 105.11 48.53 105.11 47.36 106.01 46.47 107.18 46.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "111.25 52.21 111.25 52.59 107.15 56.68 106.77 56.68 111.25 52.21"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 104.32,
    y: 52.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 77.96,
    y: 63.66,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.76,
    y: 64.54,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 76.85,
    y: 75.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "84.89 64.54 84.89 65.8 78.75 71.94 78.75 69.61 83.82 64.54 84.89 64.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "84.89 72.11 84.89 73.28 83.41 74.76 82.25 74.76 84.89 72.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "80.82 64.54 78.75 66.6 78.75 65.44 79.65 64.54 80.82 64.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "84.89 70.29 84.89 70.66 80.79 74.76 80.42 74.76 84.89 70.29"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 77.96,
    y: 70.55,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 91.14,
    y: 63.66,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 91.94,
    y: 64.54,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 90.03,
    y: 75.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "98.07 64.54 98.07 65.8 91.93 71.94 91.93 69.61 97 64.54 98.07 64.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "98.07 72.11 98.07 73.28 96.59 74.76 95.42 74.76 98.07 72.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "94 64.54 91.93 66.6 91.93 65.44 92.83 64.54 94 64.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "98.07 70.29 98.07 70.66 93.97 74.76 93.59 74.76 98.07 70.29"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 91.14,
    y: 70.55,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 104.32,
    y: 63.66,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 105.11,
    y: 64.54,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 103.21,
    y: 75.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "111.25 64.54 111.25 65.8 105.11 71.94 105.11 69.61 110.18 64.54 111.25 64.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "111.25 72.11 111.25 73.28 109.77 74.76 108.6 74.76 111.25 72.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "107.18 64.54 105.11 66.6 105.11 65.44 106.01 64.54 107.18 64.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "111.25 70.29 111.25 70.66 107.15 74.76 106.77 74.76 111.25 70.29"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 104.32,
    y: 70.55,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "119.77 80.18 70.23 80.18 70.23 80.79 119.77 80.48 119.77 80.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.23,
    y: 79.34,
    width: 49.54,
    height: 0.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "119.77 61.55 70.23 61.55 70.23 62.16 119.77 61.86 119.77 61.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.23,
    y: 60.71,
    width: 49.54,
    height: 0.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "119.77 42.93 70.23 42.93 70.23 43.54 119.77 43.23 119.77 42.93"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.23,
    y: 42.09,
    width: 49.54,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 68.1,
    y: 38.05,
    width: 2.13,
    height: 69.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.1,
    y: 38.05,
    width: 2.13,
    height: 69.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 119.77,
    y: 38.05,
    width: 2.13,
    height: 69.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.77,
    y: 38.05,
    width: 2.13,
    height: 69.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 109.36,
    y: 85.55,
    width: 1.83,
    height: 20.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 109.36,
    y: 85.55,
    width: 1.83,
    height: 20.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 78.81,
    y: 85.55,
    width: 1.83,
    height: 20.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 78.81,
    y: 85.55,
    width: 1.83,
    height: 20.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 75.25,
    y: 106.47,
    width: 39.49,
    height: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 77.18,
    y: 105.76,
    width: 35.64,
    height: 0.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "112.82 106.29 77.18 106.11 77.18 106.47 112.82 106.47 112.82 106.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 24.02,
    y: 57.2,
    width: 44.09,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.02,
    y: 57.2,
    width: 44.09,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 24.02,
    y: 99.62,
    width: 44.09,
    height: 7.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 29.02,
    y: 63.58,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 29.82,
    y: 64.45,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 27.91,
    y: 75.55,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "35.95 64.46 35.95 65.72 29.82 71.86 29.82 69.52 34.88 64.46 35.95 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "35.95 72.03 35.95 73.2 34.47 74.67 33.31 74.67 35.95 72.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "31.88 64.46 29.82 66.52 29.82 65.35 30.71 64.46 31.88 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "35.95 70.2 35.95 70.58 31.85 74.67 31.48 74.67 35.95 70.2"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 29.02,
    y: 70.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 42.2,
    y: 63.58,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 42.99,
    y: 64.45,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 41.09,
    y: 75.55,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.13 64.46 49.13 65.72 42.99 71.86 42.99 69.52 48.06 64.46 49.13 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.13 72.03 49.13 73.2 47.65 74.67 46.48 74.67 49.13 72.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "45.06 64.46 42.99 66.52 42.99 65.35 43.89 64.46 45.06 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.13 70.2 49.13 70.58 45.03 74.67 44.66 74.67 49.13 70.2"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 42.2,
    y: 70.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 55.38,
    y: 63.58,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 56.17,
    y: 64.45,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 54.27,
    y: 75.55,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "62.31 64.46 62.31 65.72 56.17 71.86 56.17 69.52 61.24 64.46 62.31 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "62.31 72.03 62.31 73.2 60.83 74.67 59.66 74.67 62.31 72.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "58.24 64.46 56.17 66.52 56.17 65.35 57.07 64.46 58.24 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "62.31 70.2 62.31 70.58 58.21 74.67 57.83 74.67 62.31 70.2"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 55.38,
    y: 70.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 29.02,
    y: 81.65,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 29.82,
    y: 82.53,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 27.91,
    y: 93.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "35.95 82.53 35.95 83.8 29.82 89.93 29.82 87.6 34.88 82.53 35.95 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "35.95 90.11 35.95 91.28 34.47 92.75 33.31 92.75 35.95 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "31.88 82.53 29.82 84.6 29.82 83.43 30.71 82.53 31.88 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "35.95 88.28 35.95 88.65 31.85 92.75 31.48 92.75 35.95 88.28"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 29.02,
    y: 88.54,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 42.2,
    y: 81.65,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 42.99,
    y: 82.53,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 41.09,
    y: 93.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.13 82.53 49.13 83.8 42.99 89.93 42.99 87.6 48.06 82.53 49.13 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.13 90.11 49.13 91.28 47.65 92.75 46.48 92.75 49.13 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "45.06 82.53 42.99 84.6 42.99 83.43 43.89 82.53 45.06 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.13 88.28 49.13 88.65 45.03 92.75 44.66 92.75 49.13 88.28"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 42.2,
    y: 88.54,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 55.38,
    y: 81.65,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 56.17,
    y: 82.53,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 54.27,
    y: 93.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "62.31 82.53 62.31 83.8 56.17 89.93 56.17 87.6 61.24 82.53 62.31 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "62.31 90.11 62.31 91.28 60.83 92.75 59.66 92.75 62.31 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "58.24 82.53 56.17 84.6 56.17 83.43 57.07 82.53 58.24 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "62.31 88.28 62.31 88.65 58.21 92.75 57.83 92.75 62.31 88.28"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 55.38,
    y: 88.54,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 22.51,
    y: 54.71,
    width: 45.59,
    height: 2.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "68.1 79.62 24.02 79.62 24.02 80.22 68.1 79.92 68.1 79.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.02,
    y: 78.77,
    width: 44.09,
    height: 0.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "64.87 57.2 68.1 57.2 68.1 107.17 67.07 107.17 64.87 57.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 121.89,
    y: 57.2,
    width: 44.09,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.89,
    y: 57.2,
    width: 44.09,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 126.9,
    y: 63.58,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 127.69,
    y: 64.45,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 125.79,
    y: 75.55,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "133.83 64.46 133.83 65.72 127.69 71.86 127.69 69.52 132.76 64.46 133.83 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "133.83 72.03 133.83 73.2 132.35 74.67 131.18 74.67 133.83 72.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "129.76 64.46 127.69 66.52 127.69 65.35 128.59 64.46 129.76 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "133.83 70.2 133.83 70.58 129.73 74.67 129.36 74.67 133.83 70.2"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 126.9,
    y: 70.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 140.08,
    y: 63.58,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 140.87,
    y: 64.45,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 138.97,
    y: 75.55,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "147.01 64.46 147.01 65.72 140.87 71.86 140.87 69.52 145.94 64.46 147.01 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "147.01 72.03 147.01 73.2 145.53 74.67 144.36 74.67 147.01 72.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "142.94 64.46 140.87 66.52 140.87 65.35 141.77 64.46 142.94 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "147.01 70.2 147.01 70.58 142.91 74.67 142.53 74.67 147.01 70.2"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 140.08,
    y: 70.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 153.25,
    y: 63.58,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 154.05,
    y: 64.45,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 152.15,
    y: 75.55,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "160.18 64.46 160.18 65.72 154.05 71.86 154.05 69.52 159.11 64.46 160.18 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "160.18 72.03 160.18 73.2 158.71 74.67 157.54 74.67 160.18 72.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "156.12 64.46 154.05 66.52 154.05 65.35 154.95 64.46 156.12 64.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "160.18 70.2 160.18 70.58 156.09 74.67 155.71 74.67 160.18 70.2"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 153.25,
    y: 70.47,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 126.9,
    y: 81.65,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 127.69,
    y: 82.53,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 125.79,
    y: 93.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "133.83 82.53 133.83 83.8 127.69 89.93 127.69 87.6 132.76 82.53 133.83 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "133.83 90.11 133.83 91.28 132.35 92.75 131.18 92.75 133.83 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "129.76 82.53 127.69 84.6 127.69 83.43 128.59 82.53 129.76 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "133.83 88.28 133.83 88.65 129.73 92.75 129.36 92.75 133.83 88.28"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 126.9,
    y: 88.54,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 140.08,
    y: 81.65,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 140.87,
    y: 82.53,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 138.97,
    y: 93.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "147.01 82.53 147.01 83.8 140.87 89.93 140.87 87.6 145.94 82.53 147.01 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "147.01 90.11 147.01 91.28 145.53 92.75 144.36 92.75 147.01 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "142.94 82.53 140.87 84.6 140.87 83.43 141.77 82.53 142.94 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "147.01 88.28 147.01 88.65 142.91 92.75 142.53 92.75 147.01 88.28"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 140.08,
    y: 88.54,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 153.25,
    y: 81.65,
    width: 7.72,
    height: 11.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 154.05,
    y: 82.53,
    width: 6.13,
    height: 10.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 152.15,
    y: 93.63,
    width: 9.93,
    height: 1.72
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "160.18 82.53 160.18 83.8 154.05 89.93 154.05 87.6 159.11 82.53 160.18 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "160.18 90.11 160.18 91.28 158.71 92.75 157.54 92.75 160.18 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "156.12 82.53 154.05 84.6 154.05 83.43 154.95 82.53 156.12 82.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "160.18 88.28 160.18 88.65 156.09 92.75 155.71 92.75 160.18 88.28"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 153.25,
    y: 88.54,
    width: 7.72,
    height: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 121.9,
    y: 54.71,
    width: 45.59,
    height: 2.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 121.9,
    y: 99.62,
    width: 44.09,
    height: 7.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "165.98 79.62 121.9 79.62 121.9 80.22 165.98 79.92 165.98 79.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.9,
    y: 78.77,
    width: 44.09,
    height: 0.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "125.13 57.2 121.9 57.2 121.9 107.17 122.93 107.17 125.13 57.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 74.33,
    y: 31.12,
    width: 41.34,
    height: 8.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.33,
    y: 38.21,
    width: 41.34,
    height: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.33,
    y: 31.91,
    width: 41.34,
    height: 0.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.09,36.28c.11-.14.32-.15.45-.04.33.27.74.43,1.16.45.27,0,.53-.07.76-.22.16-.1.25-.27.26-.45,0-.07-.02-.14-.05-.19-.05-.07-.11-.14-.18-.18-.26-.15-.54-.24-.83-.29h0c-.27-.05-.53-.13-.78-.24-.23-.09-.42-.25-.57-.45-.09-.15-.14-.32-.14-.5,0-.36.19-.7.49-.91.31-.21.67-.33,1.05-.32.48.03.94.19,1.33.48.14.09.18.29.08.43,0,0,0,0,0,0-.09.14-.27.19-.42.1,0,0,0,0-.01,0-.28-.23-.62-.36-.98-.39-.24,0-.48.07-.68.21-.14.08-.23.22-.23.38,0,.06,0,.12.04.17.04.06.1.12.16.16.23.14.49.23.76.27h0c.29.05.57.14.84.26.25.1.46.28.61.5.1.16.15.33.15.52-.01.38-.21.73-.52.94-.33.23-.72.36-1.12.35-.57-.03-1.12-.24-1.56-.61-.12-.11-.14-.28-.06-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.09,35.15c.02-1.22,1.02-2.19,2.23-2.19.51,0,1,.15,1.4.45.14.12.17.34.06.49-.12.15-.33.18-.48.06-.28-.22-.62-.34-.98-.33-.41,0-.8.17-1.1.45-.28.28-.45.66-.45,1.06,0,.4.17.78.45,1.05.29.28.69.45,1.1.45.35,0,.7-.11.98-.33.16-.1.36-.07.48.07.11.15.08.36-.06.48-.4.3-.9.46-1.4.45-1.21,0-2.21-.96-2.23-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.97,37v-3.58c0-.18.14-.33.33-.33,0,0,0,0,0,0,.18,0,.34.15.34.33,0,0,0,0,0,0v1.46h1.57v-1.46c0-.18.14-.33.33-.33,0,0,0,0,0,0,.19,0,.34.15.34.33v3.58c0,.18-.15.33-.33.33,0,0,0,0,0,0-.18,0-.33-.14-.33-.33,0,0,0,0,0,0v-1.46h-1.57v1.46c0,.18-.14.33-.33.33,0,0,0,0-.01,0-.18,0-.33-.14-.34-.33,0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.45,33.61c.39.42.61.97.62,1.54,0,.57-.22,1.12-.62,1.53-.37.41-.9.65-1.45.65-.57,0-1.1-.24-1.49-.65-.39-.41-.61-.96-.6-1.53,0-.57.21-1.12.6-1.54.39-.41.92-.65,1.49-.65.55,0,1.08.24,1.45.65Zm-.08,1.54c0-.39-.15-.77-.42-1.06-.49-.54-1.32-.58-1.85-.09-.03.03-.06.06-.09.09-.27.29-.42.67-.42,1.06,0,.39.14.77.42,1.05.47.54,1.29.59,1.83.11.04-.04.08-.07.11-.11.27-.29.42-.66.42-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.55,33.61c.39.42.61.97.62,1.54,0,.57-.22,1.12-.62,1.53-.37.41-.9.65-1.45.65-.56,0-1.1-.24-1.48-.65-.39-.41-.61-.96-.6-1.53,0-.57.21-1.12.6-1.54.38-.41.92-.65,1.48-.65.55,0,1.08.24,1.45.65Zm-.08,1.54c0-.39-.15-.77-.41-1.06-.49-.54-1.32-.58-1.86-.09-.03.03-.06.06-.09.09-.27.29-.41.67-.41,1.06,0,.39.14.77.41,1.05.48.54,1.3.59,1.83.11.04-.04.08-.07.11-.11.27-.29.41-.66.41-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m105.33,37v-3.58c0-.18.15-.33.33-.33.19,0,.34.15.34.33v3.24h1.65c.19.02.32.19.3.38-.02.16-.14.28-.3.3h-1.99c-.18,0-.33-.15-.34-.33,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 27.2,
    y: 96.66,
    width: 2.88,
    height: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m28.47,98.91c-.85,0-2.03.04-2.87.04h-.03v-1.06h.05c.85,0,2.04,0,2.87.02h.02v.02l-.02,1h-.01Zm0-.01l-.02-.98.02.02h-2.87l.04-.05v1l-.04-.04c.83,0,2.03.02,2.87.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m77.14,69.05c-.85,0-2.03.04-2.88.04h-.04v-1.06h.05c.85,0,2.04,0,2.88.02h.02v.02l-.02,1h0Zm0-.01l-.02-1,.02.02h-2.88l.04-.05v1l-.04-.04c.83,0,2.04.03,2.88.04v.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 72.66,
    y: 69.31,
    width: 2.88,
    height: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m73.94,69.05c-.85,0-2.03.04-2.88.04h-.04v-1.08h.05c.85,0,2.04,0,2.88.02h.02v.02l-.02,1h0Zm0,0l-.02-1,.02.02h-2.88l.04-.05v1l-.04-.04c.83,0,2.04.03,2.88.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m162.98,61.86c-.85,0-2.03.04-2.88.04h-.04v-1.06h.05c.85,0,2.04,0,2.88.02h.02v.02l-.02.99h0Zm0-.01l-.02-.99.02.02h-2.88l.04-.04v.99l-.04-.04c.83,0,2.04.02,2.88.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m162.98,82.15c-.85,0-2.03.04-2.88.04h-.04v-1.08h.05c.85,0,2.04,0,2.88.02h.02v.02l-.02.99h0Zm0,0l-.02-.99.02.02-1.44.02h-1.44l.04-.04v.99l-.04-.04c.83,0,2.04.02,2.88.04h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 161.68,
    y: 59.61,
    width: 2.88,
    height: 0.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 125.27,
    y: 61.67,
    width: 2.88,
    height: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m128.16,98.65c-.85,0-2.03.04-2.88.04h-.04v-1.08h.05c.85,0,2.04,0,2.88.02h.02v.02l-.02.99h0Zm0,0l-.02-.99.02.02h-2.88l.04-.04v.99l-.04-.04c.83,0,2.04.03,2.88.04v.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 126.86,
    y: 96.4,
    width: 2.88,
    height: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m161.36,60.6c-.85,0-2.03.04-2.87.04h-.04v-1.06h.05c.85,0,2.04,0,2.87.02h.02v.02l-.02.99h0Zm0-.01l-.02-.99.02.02-1.43.02h-1.44l.04-.04v.99l-.04-.04c.83,0,2.03.02,2.87.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.87,71.05c-.85,0-2.03.04-2.88.04h-.04v-1.06h.05c.85,0,2.04,0,2.88.02h.02v.02l-.02.99h0Zm0-.01l-.02-.99.02.02-1.44.02h-1.44l.05-.05v.99l-.04-.04c.83,0,2.04.02,2.88.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m75.55,98.3c-.85,0-2.03.04-2.88.04h-.04v-1.06h.05c.85,0,2.04,0,2.88.02h.02v.02l-.02.99h-.01Zm0-.01l-.02-.99.02.02-1.44.02h-1.43l.05-.04v.99l-.05-.02c.83,0,2.04.02,2.88.04h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.66,71.05c-.85,0-2.03.04-2.88.04h-.04v-1.06h.04c.85,0,2.04,0,2.88.02h.02v.02l-.02.99h0Zm0-.01l-.02-.99.02.02-1.44.02h-1.44l.05-.05v.99l-.04-.04c.83,0,2.04.02,2.88.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m116.46,88.14c-.85,0-2.03.04-2.87.04h-.04v-1.06h.05c.85,0,2.04,0,2.87.02h.02v.02l-.02,1h0Zm0-.01l-.02-1,.02.02h-2.86l.04-.05v1l-.04-.04c.83,0,2.03.03,2.87.04l-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m116.46,47.39c-.85,0-2.03.04-2.87.04h-.04v-1.06h.05c.85,0,2.04,0,2.87.02h.02v.02l-.02.99h0Zm0-.01l-.02-.99.02.02h-2.86l.04-.04v.99l-.04-.04c.83,0,2.03.02,2.87.04l-.02.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 115.19,
    y: 47.65,
    width: 2.88,
    height: 0.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 51.03,
    y: 58.78,
    width: 2.88,
    height: 0.99
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m18.68,109.84c48.89-.22,103.74-.22,152.64,0-48.89.22-103.74.22-152.64,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 21.09,
    y: 107.18,
    width: 147.82,
    height: 2.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m31.45,107.18c.23.84.23,1.73,0,2.58-.12-.42-.18-.85-.18-1.29,0-.44.05-.87.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m43.01,107.18c.12.42.18.85.18,1.29,0,.44-.05.87-.18,1.29-.23-.84-.23-1.73,0-2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m54.56,107.18c.23.84.23,1.73,0,2.58-.12-.42-.18-.85-.18-1.29,0-.44.05-.87.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m66.11,107.18c.12.42.18.85.18,1.29,0,.44-.05.87-.18,1.29-.23-.84-.23-1.73,0-2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m77.67,107.18c.23.84.23,1.73,0,2.58-.12-.42-.18-.85-.18-1.29,0-.44.05-.87.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m89.22,107.18c.12.42.18.85.18,1.29,0,.44-.05.87-.18,1.29-.23-.84-.23-1.73,0-2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m100.78,107.18c.23.84.23,1.73,0,2.58-.12-.42-.18-.85-.18-1.29,0-.44.05-.87.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m112.33,107.18c.12.42.18.85.18,1.29,0,.44-.05.87-.18,1.29-.23-.84-.23-1.73,0-2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m123.89,107.18c.23.84.23,1.73,0,2.58-.12-.42-.18-.85-.18-1.29,0-.44.05-.87.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m135.44,107.18c.12.42.18.85.18,1.29,0,.44-.05.87-.18,1.29-.23-.84-.23-1.73,0-2.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m146.99,107.18c.23.84.23,1.73,0,2.58-.12-.42-.18-.85-.18-1.29,0-.44.05-.87.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m158.55,107.18c.12.42.18.85.18,1.29,0,.44-.05.87-.18,1.29-.23-.84-.23-1.73,0-2.58h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m37.76,107.18s-.3-1.39-.89-1.6-.96.41-.96.41c0,0-.14-1.33-.98-1.73s-1.48.42-1.48.42c0,0-.65-1.69-1.81-1.69s-1.74,2.48-1.74,2.48c0,0-.68-.73-1.39-.32s-.71,2.04-.71,2.04h9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m136.54,107.18s-.3-1.39-.89-1.6-.96.41-.96.41c0,0-.14-1.33-.98-1.73s-1.48.42-1.48.42c0,0-.65-1.69-1.81-1.69s-1.74,2.48-1.74,2.48c0,0-.68-.73-1.38-.32s-.71,2.04-.71,2.04h9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m64.07,107.18h-10.47s.35-1.47,1.04-1.58c.43-.04.83.19,1.02.58,0,0-.03-2.06,1.26-2.41s2.38,1.47,2.38,1.47c0,0,.81-1.03,1.92-.97s1.39,1.77,1.39,1.77c0,0,1.01-.58,1.45,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m28.46,107.18h-5.51s0-.82.55-1.04c.3-.13.65-.05.86.21,0,0,.22-1.51,1.23-1.51s1.49,1.3,1.49,1.3c.18-.25.48-.38.79-.32.56.07.58,1.36.58,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m68.4,107.18h-5.51s0-.82.55-1.04c.3-.13.65-.05.86.21,0,0,.22-1.51,1.23-1.51s1.48,1.3,1.48,1.3c.18-.25.48-.38.79-.32.57.07.6,1.36.6,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m159.01,107.18h-5.51s0-.82.55-1.04c.3-.13.65-.05.86.21,0,0,.22-1.51,1.23-1.51s1.49,1.3,1.49,1.3c.17-.25.48-.38.79-.32.56.07.58,1.36.58,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m167.05,107.18h-9.08s.02-1.35.91-1.71c.5-.21,1.08-.07,1.42.35,0,0,.35-2.48,2.03-2.48s2.46,2.13,2.46,2.13c.29-.42.8-.63,1.3-.53.93.12.97,2.24.97,2.24Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent21);
export default __webpack_public_path__ + "static/media/event2-1.c435d76059cc12eb3787447f6f486810.svg";
export { ForwardRef as ReactComponent };